import { getCurrentEnvironment } from '@telstra-connect/config/config';
import { flagIsSet } from '@telstra-connect/feature-flags';
import { IFeatureFlags } from './common';
import flagsData from './flags';

let featureFlags: IFeatureFlags;

export const loadFeatureFlags = (): void => {

    const environment = getCurrentEnvironment();

    // the step to check for flags is implemented statically to have typescript/intellisense support
    featureFlags = Object.freeze({
        // example usage:
        ticketSubmit: flagIsSet(flagsData.ticketSubmit, environment),
        resolutionConfirmation: flagIsSet(flagsData.resolutionConfirmation, environment),
        liveChat: flagIsSet(flagsData.liveChat, environment),
        chartsDashboard: flagIsSet(flagsData.chartsDashboard, environment),
        customerReference: flagIsSet(flagsData.customerReference, environment),
        customerReferenceErrorScenario: flagIsSet(flagsData.customerReferenceErrorScenario, environment),
        staffAccessChatIcon: flagIsSet(flagsData.staffAccessChatIcon, environment),
        buttonIntegrations: flagIsSet(flagsData.buttonIntegrations, environment)
    });
};

export const getIncidentManagementFlags = (): IFeatureFlags => {
    return featureFlags;
};
